module.exports = __webpack_public_path__ + "static/media/event-mark.bcbf04db.svg";